export const USER_LOGIN_PROCESS = "USER_LOGIN_PROCESS"
export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS"
export const USER_LOGIN_FAILURE = "USER_LOGIN_FAILURE"

export const MAIN_DOCTOR_SIGNUP_PROCESS = "MAIN_DOCTOR_SIGNUP_PROCESS"
export const MAIN_DOCTOR_SIGNUP_SUCCESS = "MAIN_DOCTOR_SIGNUP_SUCCESS"
export const MAIN_DOCTOR_SIGNUP_FAILURE = "MAIN_DOCTOR_SIGNUP_FAILURE"

